import { render, staticRenderFns } from "./getUrl.vue?vue&type=template&id=785071ba"
import script from "./getUrl.vue?vue&type=script&lang=js"
export * from "./getUrl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports